<template>
	<div class="app-container">
		<div class="filter-container">
			<el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
				<el-form-item prop="address">
					<el-input v-model="listQuery.name" placeholder="请输入场地名称" clearable @change="SearchData"
						@keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item prop="type">
					<el-select v-model="listQuery.site_id" placeholder="请选择门店名称" filterable clearable>
						<el-option v-for="item in siteList" :key="item.value" :value="item.id" :label="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="type">
					<el-select v-model="listQuery.type" placeholder="请选择门店类型" :disabled="!listQuery.site_id" clearable
						@change="SearchData">
						<el-option v-for="item in dictionary" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="status">
					<el-select v-model="listQuery.status" placeholder="请选择场地状态" clearable @change="SearchData">
						<el-option label="启用" value="1"></el-option>
						<el-option label="停用" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--动作组-->
		<div class="action-container">
			<el-button-group>
				<!-- 弹窗层编辑 -->
				<el-button v-auth="'Space.create'" class="action-item" type="primary" icon="el-icon-edit"
					@click="HandleCreate">添加</el-button>
				<el-button v-auth="'Space.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>

			</el-button-group>
		</div>
		<!--表开始-->
		<el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row
			style="width: 100%" @sort-change="sortChange">
			<!--列开始-->
			<el-table-column type="selection"></el-table-column>
			<el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
			<el-table-column align="center" prop="site_name" label="门店名称"> </el-table-column>
			<el-table-column align="center" prop="name" label="场地名称 "> </el-table-column>
			<el-table-column align="center" prop="status" label="开启状态 " width="150">
				<template slot-scope="{ row }">
					<el-switch v-model="row.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用"
						@change="changeState(row)" />
				</template>
			</el-table-column>
			<el-table-column align="center" prop="type_name" label="场地类型 "> </el-table-column>
			<!-- <el-table-column align="center" prop="is_use" label="使用情况 ">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.is_use == 1">使用中</el-tag>
          <el-tag type="warning" v-else>未使用</el-tag>
        </template>
      </el-table-column> -->
			<el-table-column align="center" prop="create_time" label="创建时间 "> </el-table-column>
			<el-table-column align="center" prop="" label="操作" class-name="action" width="400">
				<template slot-scope="scopes">
					<el-button v-auth="'Space.video'" icon="el-icon-upload" type="success" size="mini"
						@click="uploadVideo(scopes.row)">上传视频</el-button>
					<el-button v-auth="'Space.serial'" icon="el-icon-video-camera" type="info" size="mini"
						@click="uploadserial(scopes.row)">设备管理</el-button>
					<el-button v-auth="'Space.update'" icon="el-icon-edit" type="primary" size="mini"
						@click="HandleUpdate(scopes.row)">编辑</el-button>
					<el-button v-auth="'Space.delete'" icon="el-icon-delete" size="mini" type="danger"
						@click="RowDelete(scopes.row)">删除</el-button>
				</template>
			</el-table-column>
			<!--列结束-->
		</el-table>
		<!--分页-->
		<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
			@pagination="loadData" />
		<!--弹窗编辑/新增窗体-->
		<el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible" width="80%">
			<el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px"
				style="width: 100%;">
				<el-form-item label="门店名称" prop="site_id">
					<el-select v-model="temp.site_id" placeholder="请选择门店名称" filterable clearable style="width: 100%;">
						<el-option v-for="item in siteList" :key="item.value" :value="item.id" :label="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="场地名称" prop="name">
					<el-input v-model="temp.name" maxlength="6" show-word-limit placeholder="请输入场地名称" />
				</el-form-item>
				<el-form-item label="开启状态" prop="status">
					<el-switch v-model="temp.status" active-color="#13ce66" :active-value="1" :inactive-value="0" active-text="启用"
						inactive-text="停用"></el-switch>
				</el-form-item>
				<el-form-item label="场地类型" prop="type">
					<el-select v-model="temp.type" placeholder="请选择场地类型" style="width: 100%;" :disabled="!temp.site_id">
						<el-option v-for="item in Tempdictionary" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="showTimePriceSection" label="分时价格设置">
					<el-row :gutter="24">
						<el-col v-for="(slot, idx) in temp.time_prices" :key="'time-slot-' + idx + '-' + slot.start_time" :span="24"
							style="margin-bottom: 10px;">
							<el-card shadow="never">
								<el-row :gutter="24" type="flex" align="middle">
									<el-col :span="6">
										<el-tag type="info">{{ slot.start_time }}-{{ slot.end_time }}</el-tag>
									</el-col>
									<el-col :span="6">
										<el-select v-model="slot.time_type" placeholder="请选择" @change="handleTimeTypeChange(idx, $event)">
											<el-option v-for="opt in hourSelectOptions" :key="opt.value" :label="opt.label"
												:value="opt.value"></el-option>
										</el-select>
									</el-col>
									<el-col :span="6">
										<el-form-item label="普通用户价格" :rules="[{ required: true, message: '请输入普通用户价格', trigger: 'blur' }]">
											<el-input-number v-model="slot.normal_price" :min="1" :max="10000" :precision="2" :step="0.5"
												placeholder="请输入价格" />
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<el-form-item label="会员用户价格" :rules="[{ required: true, message: '请输入会员用户价格', trigger: 'blur' }]">
											<el-input-number v-model="slot.vip_price" :min="1" :max="10000" :precision="2" :step="0.5"
												placeholder="请输入价格" />
										</el-form-item>
									</el-col>
								</el-row>
							</el-card>
						</el-col>
					</el-row>
				</el-form-item>
				<!-- <el-form-item label="使用情况" prop="is_use">
          <el-switch v-model="temp.is_use" active-color="#13ce66" :active-value="1" :inactive-value="0" active-text="使用" inactive-text="空闲"></el-switch>
        </el-form-item> -->
				<el-form-item label="排序" prop="order_no">
					<el-input-number v-model="temp.order_no" :min="1" :max="99999" />
					<p class="tishi">排序越小，小程序展示越靠前</p>
				</el-form-item>
				<!-- <el-form-item label="场地详情" prop="content">
                <WangEditor v-model="temp.content" :value.sync="temp.content" />
        </el-form-item> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取消</el-button>
				<el-button type="primary" @click="ConfirmData">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import api from '@/api/site/space' // 和数据交互相关写在api 方便复用
	import siteapi from '@/api/site/site' // 和数据交互相关写在api 方便复用
	import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
	import commonList from '@/utils/commonList'
	// import WangEditor from '@/components/WangEditor'
	// import FileList from '@/components/attachment/FileList'
	import dict_data from '@/api/system/dict_data'

	export default {
		name: 'Space',
		components: {
			Pagination
		},
		// 列绑定格式化器
		filters: {},
		mixins: [commonList],
		data() {
			return {
				// api接口方法
				api,
				// 校验
				rules: {
					site_id: [{
						required: true,
						message: '请选择门店',
						trigger: 'blur,change'
					}],
					name: [{
						required: true,
						message: '请输入场地名称',
						trigger: 'blur,change'
					}],
					type: [{
						required: true,
						message: '请选择场地类型',
						trigger: 'blur,change'
					}]
				},
				temp: {},
				listQuery: {
					page: 1,
					limit: 10, // 页大小
					order: 'DESC', // 默认排序方式,
					sort: 'id',
					site_id: '',
					name: '',
					type: '',
					status: ''
				},
				siteList: [], // 门店
				changeone: 1,
				// 字典参数
				dictionary: [],
				Tempdictionary: [],
				startTime: '06:00',
				endTime: '20:00',
				hourSelectOptions: [{
						label: '闲时',
						value: 1
					},
					{
						label: '忙时',
						value: 2
					}
				],
				showTimePriceSection: false, // 控制分时价格设置区域显示
				isLoadingTimeSlots: false // 加载时间段的状态
				// 字典参数
			}
		},
		watch: {
			'listQuery.site_id': {
				handler(newValue, oldValue) {
					if (newValue !== oldValue || newValue === '') {
						this.listQuery.type = ''
						this.SearchData()
					}
					if (newValue !== '' && newValue !== null) {
						this.getTypeList(newValue) // 场地类型
					}
				}
			},
			'temp.site_id': {
				handler(newValue, oldValue) {
					// if ((newValue != oldValue && this.changeone==1) || (newValue == "" && this.changeone==1)) {
					//   this.temp.type = "";
					// }
					if (this.changeone === 1) {
						this.temp.type = ''
					}
					this.changeone = 1
					if (newValue !== '' && newValue != null) {
						this.getTempTypeList(newValue) // 场地类型
						this.loadTimeSlotsForSite(newValue) // 加载时间段
					} else {
						// 清空门店时，隐藏分时价格设置
						this.showTimePriceSection = false
						this.temp.time_prices = []
					}
				}
			}
		},
		created() {
			this.loadData()
			// 门店列表
			this.siteListSearch()
		},
		methods: {
			// 显示编辑窗体
			HandleUpdate(row) {
				this.changeone = 2
				this.temp = Object.assign({}, row) // copy obj

				// 先显示对话框
				this.dialogStatus = 'update'
				this.dialogFormVisible = true

				// 使用 $nextTick 确保对话框已渲染
				this.$nextTick(() => {
					// 加载时间段价格数据
					if (this.temp.id) {
						api.Detail(this.temp.id).then(response => {
							console.log('场地详情数据:', response)
							if (response.code === 200 && response.data) {
								// 合并详情数据到 temp，但保留 type 的字符串格式
								const detailData = response.data

								// 处理 type 字段：确保是字符串格式
								if (detailData.type) {
									detailData.type = detailData.type.toString()
								}

								// 处理 time_prices 数据：确保类型正确
								if (detailData.time_prices && detailData.time_prices.length > 0) {
									detailData.time_prices = detailData.time_prices.map(item => ({
										...item,
										time_type: parseInt(item.time_type),
										normal_price: parseFloat(item.normal_price) || 0,
										vip_price: parseFloat(item.vip_price) || 0
									}))

									console.log('时间段价格数据:', detailData.time_prices)

									// 使用 $set 确保响应式更新
									this.$set(this.temp, 'time_prices', detailData.time_prices)
									this.showTimePriceSection = true
								} else {
									console.log('没有时间段数据，根据门店加载')
									// 如果没有时间段数据，根据门店加载
									if (this.temp.site_id) {
										this.loadTimeSlotsForSite(this.temp.site_id)
									}
								}

								// 合并其他字段（除了 time_prices）
								Object.keys(detailData).forEach(key => {
									if (key !== 'time_prices') {
										this.$set(this.temp, key, detailData[key])
									}
								})
							}
						}).catch(error => {
							console.error('加载场地详情失败:', error)
							// 如果加载失败，尝试根据门店加载时间段
							if (this.temp.site_id) {
								this.loadTimeSlotsForSite(this.temp.site_id)
							}
						})
					}
				})
			},
			// 上传视频
			uploadVideo(data) {
				this.$router.push({
					path: '/site/video',
					query: {
						id: data.id,
						site_id: data.site_id
					}
				})
			},
			// 设备管理
			uploadserial(data) {
				this.$router.push({
					path: '/site/serial',
					query: {
						id: data.id,
						site_id: data.site_id
					}
				})
			},
			// 门店列表
			siteListSearch() {
				siteapi.getList().then((response) => {
					this.siteList = response.data
				})
			},
			// 场地类型
			getTypeList(id) {
				dict_data
					.getAppointList({
						code: 'mdlx',
						siteid: id
					})
					.then((response) => {
						this.dictionary = response.data
					})
			},
			// 场地类型
			getTempTypeList(id) {
				dict_data
					.getAppointList({
						code: 'mdlx',
						siteid: id
					})
					.then((response) => {
						this.Tempdictionary = response.data
						this.$forceUpdate()
					})
			},
			// 更新状态
			changeState(row) {
				api.ChangeStatus({
					id: row.id,
					status: row.status
				}).then(response => {
					this.$notify({
						title: '成功',
						message: response.msg,
						type: 'success'
					})
				})
			},
			resetTemp() {
				this.temp = {
					id: undefined,
					order_no: 99999,
					name: '',
					status: 1,
					type: '',
					site_id: '',
					time_prices: []
				}
				this.showTimePriceSection = false // 重置时隐藏分时价格设置
			},
			// 根据门店ID加载时间段
			loadTimeSlotsForSite(siteId) {
				if (!siteId) {
					this.showTimePriceSection = false
					this.$set(this.temp, 'time_prices', [])
					return
				}

				this.isLoadingTimeSlots = true
				api.GetTimeSlotsBySite(siteId).then(response => {
					if (response.code === 200) {
						// 确保 time_type 是数字类型
						const timePrices = response.data.map(item => ({
							...item,
							time_type: parseInt(item.time_type),
							normal_price: parseFloat(item.normal_price) || 0,
							vip_price: parseFloat(item.vip_price) || 0
						}))

						console.log('加载的时间段数据:', timePrices)

						// 使用 $set 确保响应式更新
						this.$set(this.temp, 'time_prices', timePrices)
						this.showTimePriceSection = true
					}
				}).catch(error => {
					// 处理错误
					const errorMsg = error.msg || error.message || '获取时间段失败'
					if (errorMsg.includes('请先设置门店营业时间') || errorMsg.includes('营业时间')) {
						this.$message.warning(errorMsg)
					} else {
						this.$message.error(errorMsg)
					}
					this.showTimePriceSection = false
					this.$set(this.temp, 'time_prices', [])
				}).finally(() => {
					this.isLoadingTimeSlots = false
				})
			},
			// 处理时间类型下拉框变化
			handleTimeTypeChange(index, value) {
				console.log(`时间段 ${index} 的类型变更为:`, value)
				// 使用 $set 确保响应式更新
				this.$set(this.temp.time_prices[index], 'time_type', value)
			},
			// 重写保存方法，添加时间段价格验证
			ConfirmData() {
				// 验证时间段价格
				if (this.showTimePriceSection && this.temp.time_prices && this.temp.time_prices.length > 0) {
					for (let i = 0; i < this.temp.time_prices.length; i++) {
						const slot = this.temp.time_prices[i]
						if (slot.normal_price === null || slot.normal_price === '' || slot.normal_price === undefined) {
							this.$message.error(`第${i + 1}个时间段的普通用户价格不能为空`)
							return
						}
						if (slot.vip_price === null || slot.vip_price === '' || slot.vip_price === undefined) {
							this.$message.error(`第${i + 1}个时间段的会员用户价格不能为空`)
							return
						}
					}
				}

				// 调用父类方法
				if (this.dialogStatus === 'create') {
					this.CreateData()
				} else {
					this.UpdateData()
				}
			}
		}
	}
</script>